import { css } from 'emotion'

export const CheveronDownIconStyles = css`
  transform: rotate(270deg);
`
